<template>
  <div class="hotel-container">
    <top-nav :shrinked="true"/>
    <div class="banner-container">
      <img class="banner page-banner" src="@/assets/hotel/banner.jpg">
      <div class="banner-code">
        <div class="text-content">
          <div class="middle-text">扫描二维码</div>
          <div class="middle-text">立即预定</div>
        </div>
        <img src="@/assets/hotel/banner_code.png">
      </div>
    </div>
    <div class="site-text__content">
      <h3 class="text-blue site-text__content_h3" data-aos="fade-up" data-aos-delay="100">享受生活的艺术</h3>
      <div class="site-text__content_desc" data-aos="fade-up" data-aos-delay="200">
        <p>星嘉酒管一以多元产品的高品质运营能力</p>
        <p>塑造城市高端服务品牌</p>
      </div>
    </div>
    <div class="hotel-mode-content">
      <div class="hotel-cate">
        <div class="hotel-cate-item position-re" data-aos="fade-up" @click="toCate('.cate1')">
          <img src="@/assets/hotel/cate1.jpg">
          <div class="title fs16">品牌故事</div>
        </div>
        <div class="hotel-cate-item position-re" data-aos="fade-up" @click="toCate('.cate2')">
          <img src="@/assets/hotel/cate2.jpg">
          <div class="title fs16">探索发现</div>
        </div>
        <div class="hotel-cate-item position-re" data-aos="fade-up" @click="toCate('.cate3')">
          <img src="@/assets/hotel/cate3.jpg">
          <div class="title fs16">甄选视频</div>
        </div>
      </div>
      <div class="cate1">
        <div class="site-text__content">
          <h3 class="text-blue site-text__content_h3" data-aos="fade-up" data-aos-delay="100">品牌故事</h3>
          <div class="site-text__content_desc" style="text-align:left;text-indent:2em;" data-aos="fade-up" data-aos-delay="200">
            <p>星嘉酒管是嘉宏资管公司旗下集酒店管理、酒店顾问、酒店培训于一体的专业酒店管理公司,以多元产品的高品质运营能力,塑造城市高端服务品牌。目前已签约美国温德姆酒店、法国雅高酒店集团,另外强强联合万达美华等国际品牌,并获得“年度新开业酒店大奖”等荣誉。</p>
          </div>
        </div>
        <div class="slider__content">
          <div class="slider1 cate-one">
            <div v-for="(item,index) in hotels" :key="index" data-aos="fade-up" data-aos-delay="100" class="cate-one-item" @click="hotelClick(index)">
              <img :src="require('@/assets/hotel/'+item.imgUrl)">
              <div class="cate-one-bottom">
                <div class="fs16">{{item.name}}</div>
                <div class="line">
                  <div class="blue-line"></div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isMobile" class="Carousel_carouselControls__HecEP carouselControls">
            <div class="Carousel_carouselPagination__dClSG carouselPagination">
                <span v-for="(item,index) in hotels" :key="index"
                    class="Carousel_carouselPaginationItem__g0Rld carouselPaginationItem"
                    :class="{'Carousel_carouselPaginationActive__fh9Dk carouselPaginationActive':currentSlide1===index}"
                    @click="paginationClick(index)">
                </span>
            </div>
          </div>
        </div>
      </div>
      <div class="cate2" style="display:none;">
        <div class="site-text__content">
          <h3 class="text-blue site-text__content_h3" data-aos="fade-up" data-aos-delay="100">探索发现</h3>
        </div>
        <div class="cate-two">
          <div class="cate-two-left">
            <div class="cate-two-left-item">
              <span class="fs16">嘉宏温德姆酒店</span>
              <div class="display-row cate-two-left-item-content">
                <img class="left-icon" src="@/assets/hotel/icon_1.png"/>
                <div class="cate-two-address">
                  <div class="cate-two-left-icon">
                    <img src="@/assets/business/address.png" alt=""/>
                    <div>江苏省常州市新北区孟河镇孟河大道转盘中心西南侧</div>
                  </div>
                  <div class="cate-two-left-icon">
                    <img src="@/assets/business/phone.png" alt=""/>
                    <div class="fonts16">0519-8626 9999</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="cate-two-left-item">
              <span class="fs16">嘉宏美爵酒店</span>
              <div class="display-row cate-two-left-item-content">
                <img class="left-icon" src="@/assets/hotel/icon_2.png"/>
                <div class="cate-two-address">
                  <div class="cate-two-left-icon">
                    <img src="@/assets/business/address.png"/>
                    <div>江苏省常州市新北区黄河西路与通江路交汇处</div>
                  </div>
                  <div class="cate-two-left-icon">
                    <img src="@/assets/business/phone.png"/>
                    <div class="fonts16">18961822257</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="cate-two-left-item">
              <span class="fs16">蔚蓝卡地亚餐厅</span>
              <div class="display-row cate-two-left-item-content">
                <img class="left-icon" src="@/assets/hotel/icon_3.png"/>
                <div class="cate-two-address">
                  <div class="cate-two-left-icon">
                    <img src="@/assets/business/address.png"/>
                    <div>江苏省常州市钟楼区晋陵路8号（星光天地5号门对面）</div>
                  </div>
                  <div class="cate-two-left-icon">
                    <img src="@/assets/business/phone.png"/>
                    <div class="fonts16">13776859009</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cate-two-right">
            <img src="@/assets/hotel/map2.png"/>
          </div>
        </div>
      </div>
      <div class="cate3">
        <div class="site-text__content">
          <h3 class="text-blue site-text__content_h3" data-aos="fade-up" data-aos-delay="100">甄选视频</h3>
        </div>
        <div class="hotel-cate" data-aos="fade-up" data-aos-delay="200">
          <div class="hotel-cate-item text-center">
            <div class="video-item">
              <video
                      id="video1"
                      class="hotel-video-class"
                      webkit-playsinline="true"
                      x-webkit-airplay="true"
                      playsinline="true"
                      x5-video-player-type="h5"
                      preload='auto'
                      poster="@/assets/hotel/poster_1.jpg"
                      loop>
                <source src="@/assets/hotel/video1.mp4" type="video/mp4">
              </video>
              <div v-if="videos['video1'].button" class="video-btn" @click="videoClick('video1')"></div>
            </div>
            <div class="mar-top text-black" data-aos="fade-up" data-aos-delay="100">嘉宏温德姆酒店</div>
            <div class="fs12" data-aos="fade-up" data-aos-delay="200">常州新北区域标志性酒店</div>
          </div>
          <div class="hotel-cate-item text-center">
            <div class="video-item">
              <video
                      id="video2"
                      class="hotel-video-class"
                      webkit-playsinline="true"
                      x-webkit-airplay="true"
                      playsinline="true"
                      x5-video-player-type="h5"
                      preload='auto'
                      poster="@/assets/hotel/poster_2.jpg"
                      loop>
                <source src="@/assets/hotel/video2.mp4" type="video/mp4">
              </video>
              <div v-if="videos['video2'].button" class="video-btn" @click="videoClick('video2')"></div>
            </div>
            <div class="mar-top text-black" data-aos="fade-up" data-aos-delay="100">嘉宏美爵酒店</div>
            <div class="fs12" data-aos="fade-up" data-aos-delay="200">立足于当地，服务于当地</div>
          </div>
          <div class="hotel-cate-item text-center">
            <div class="video-item">
              <video
                      id="video3"
                      class="hotel-video-class"
                      webkit-playsinline="true"
                      x-webkit-airplay="true"
                      playsinline="true"
                      x5-video-player-type="h5"
                      preload='auto'
                      poster="@/assets/hotel/poster_3.jpg"
                      loop>
                <source src="@/assets/hotel/video3.mp4#t=0.1" type="video/mp4">
              </video>
              <div v-if="videos['video3'].button" class="video-btn" @click="videoClick('video3')"></div>
            </div>
            <div class="mar-top text-black" data-aos="fade-up" data-aos-delay="100">蔚蓝卡地亚餐厅</div>
            <div class="fs12" data-aos="fade-up" data-aos-delay="200">打造都市餐饮新风尚</div>
          </div>
        </div>
      </div>
      <div>
        <div class="site-text__content">
          <h3 class="text-blue site-text__content_h3" data-aos="fade-up" data-aos-delay="100">荣誉实力</h3>
        </div>
        <div class="display-row hotel-cate-img" data-aos="fade-up" data-aos-delay="200">
          <img src="@/assets/hotel/aa.png">
<!--          <div class="hotel-cate-item position-re text-center">-->
<!--            <img src="">-->
<!--            <div class="title honor-text text-black">中国饭店业城市地标价值酒店</div>-->
<!--          </div>-->
<!--          <div class="hotel-cate-item position-re text-center">-->
<!--            <img src="">-->
<!--            <div class="title honor-text text-black">年度新开业酒店大奖</div>-->
<!--          </div>-->
<!--          <div class="hotel-cate-item position-re text-center">-->
<!--            <img src="">-->
<!--            <div class="title honor-text text-black">温德姆奖赏计划</div>-->
<!--          </div>-->
      </div>
      </div>
    </div>

    <div v-if="dialog" class="hotel-dialog display-center">
      <div class="hotel-dialog-content">
          <div class="dialog-top-content">
            <div class="dialog-address">
              <div class="fs16 hotel-dialog-title">{{dialogForm.name}}</div>
              <div class="fs12">{{dialogForm.desc}}</div>
              <div class="address-info-container">
                  <div v-for="(item,index) in dialogForm.cateList" :key="index" class="address-info-item">
                    <span class="fs20 title-big">{{item.a1}}</span>
                    <span class="text-top">{{item.a2}}</span>
                    <p>{{item.a3}}</p>
                  </div>
              </div>
            </div>
            <div class="dialog-img">
              <img :src="require('@/assets/hotel/'+dialogForm.minImg)">
            </div>
          </div>
          <div class="dialog-bottom-content">
            <div v-for="(imgItem,imgIndex) in dialogForm.imgList" :key="imgIndex">
              <img :src="require('@/assets/hotel/'+imgItem)">
            </div>
          </div>
          <div class="dialog-close" @click="close"></div>
      </div>
    </div>
  </div>
</template>


<script>
  import topNav from '@/components/base/top-nav'

  import 'slick-carousel/slick/slick.css';
  import 'slick-carousel/slick/slick-theme.css';
  import $ from 'jquery';
  import 'slick-carousel';
  var that = null
  export default {
    name: "hotel",
    components:{
      topNav
    },
    data() {
      return {
        currentSlide1:0,
        videos:{
          'video1':{
            button:true
          },
          'video2':{
            button:true
          },
          'video3':{
            button:true
          }
        },
        hotels:[
          {
            name: '嘉宏温德姆酒店',
            desc: '位于新北区孟河镇中心地段，毗邻星光城SHOPPING MALL，距离常州高铁北站仅35分钟，常州机场20分钟，距离环球恐龙城等旅游景点仅40分钟，交通十分便利。',
            cateList:[
              {
                a1:'35',
                a2:'分钟',
                a3:'至高铁北站'
              },
              {
                a1:'125',
                a2:'间',
                a3:'套间客房'
              },
              {
                a1:'50',
                a2:'桌',
                a3:'无柱宴会厅'
              },
              {
                a1:'20',
                a2:'分钟',
                a3:'至常州机场'
              },
              {
                a1:'1300',
                a2:'㎡',
                a3:'会议宴会设施'
              }
            ],
            minImg:'hotel1_min.png',
            imgUrl:'hotel_1.png',
            imgList:['hotel1_1.png','hotel1_2.png','hotel1_3.png','hotel1_4.png']
          },
          {
            name:'嘉宏美爵酒店',
            desc:'常州嘉宏美爵酒店位于新北区罗溪镇TOD中心空港国际星光城，距离常州高铁北站28分钟车程，距离常州奔牛机场仅5公里，交通网络四通八达，是罗溪首个五星标准酒店。',
            cateList:[
              {
                a1:'18',
                a2:'KM',
                a3:'至高铁北站'
              },
              {
                a1:'5',
                a2:'KM',
                a3:'至常州机场'
              },
              {
                a1:'120',
                a2:'桌',
                a3:'无柱宴会厅'
              },
              {
                a1:'182',
                a2:'间',
                a3:'套房客房'
              },
              {
                a1:'2600',
                a2:'㎡',
                a3:'会议宴会设施'
              }
            ],
            minImg:'hotel2_min.png',
            imgUrl:'hotel_2.png',
            imgList:['hotel2_1.png','hotel2_2.png','hotel2_3.png','hotel2_4.png']
          },
          {
            name:'蔚蓝卡地亚',
            desc:'蔚蓝卡地亚餐厅位于市中心青果巷商圈，毗邻嘉宏星光天地。餐厅环境优美、格调高雅，更有可容纳20人用餐的超大包间，尽显大气雅致。',
            cateList:[
              {
                a1:'',
                a2:'',
                a3:''
              },
              {
                a1:'',
                a2:'',
                a3:''
              },
              {
                a1:'',
                a2:'',
                a3:''
              },
              {
                a1:'',
                a2:'',
                a3:''
              },
              {
                a1:'',
                a2:'',
                a3:''
              }
            ],
            minImg:'hotel3_min.png',
            imgUrl:'hotel_3.png',
            imgList:['hotel3_1.png','hotel3_2.png','hotel3_3.png','hotel3_4.png']
          }
        ],
        hotelIndex: 0,
        dialogForm: {},
        dialog: false,
        isMobile: false,
      }
    },
    mounted() {
      that = this
      this.initSlider()
      this.handleResize()
      this.$nextTick(()=>{
        document.addEventListener("WeixinJSBridgeReady", function (){
          document.getElementById('video1').play();
          document.getElementById('video1').pause();
        }, false)
      })
    },
    onDestroy(){

    },
    methods: {
      handleResize(){
        this.isMobile = window.innerWidth <= 720
      },
      toCate(type){
        this.goAnchorParent(type)
      },
      goAnchorParent(selector){
        var element = document.querySelector(selector);
        var elementPosition = element.getBoundingClientRect().top;
        window.scrollBy({
          top: elementPosition - 44,
          behavior: 'smooth' // 平滑滚动
        });
      },
      /**
       * 初始化轮播
       */
      initSlider() {
        this.$nextTick(() => {
          $('.slider1').slick({
            dots:false,
            arrows: false,
            initialSlide: 0,
            slidesToShow: 3,
            slidesToScroll: 1,
            draggable:false,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  arrows: false,
                  draggable:true,
                }
              }
            ]
          });
          $('.slider1').on('afterChange', function pauseSlideShow(event, slick, currentSlide){
            that.currentSlide1 = currentSlide
          });
        });
      },
      paginationClick(index){
        that.currentSlide1 = index
        $('.slider1').slick('slickGoTo', index);
      },
      hotelClick(index){
        this.hotelIndex = index
        this.dialogForm = this.hotels[index]
        this.dialog = true
      },
      close(){
        this.dialog = false
      },
      videoClick(videoId){
        var video = document.getElementById(videoId);
        // video.addEventListener('pause', function() {
        //   that.videos[videoId].button = true
        //   video.controls = false;
        // });
        video.play();
        that.videos[videoId].button = false
        video.controls = true;
      },
    }
  }
</script>

<style>
  @import "../../styles/hotel.css";
</style>
